'use client';

import { useState, useEffect } from 'react';
import { ArrowRight, X, Sparkles } from 'lucide-react';
import { Link } from '@/i18n/routing';
import { GUARANTEE } from '@/lib/copy/guarantee';
import styles from './DemoFloatingCTA.module.css';

interface DemoFloatingCTAProps {
  issuesCount?: number;
}

export function DemoFloatingCTA({ issuesCount = 14 }: DemoFloatingCTAProps) {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Show after a short delay for better UX
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (isDismissed) return null;

  return (
    <>
      <div className={`${styles.container} ${isVisible ? styles.visible : ''}`}>
        <div className={styles.card}>
          {/* Animated border glow */}
          <div className={styles.borderGlow} />

          {/* Dismiss button */}
          <button
            className={styles.dismissButton}
            onClick={() => setIsDismissed(true)}
            aria-label="Dismiss"
          >
            <X size={16} />
          </button>

          {/* Glow effect */}
          <div className={styles.glowEffect} />

          {/* Content */}
          <div className={styles.content}>
            {/* Left side - Badge and text */}
            <div className={styles.textContent}>
              <div className={styles.badge}>
                <Sparkles size={12} />
                <span>Sample Report</span>
              </div>
              <h3 className={styles.title}>
                Like what you see?
              </h3>
              <p className={styles.description}>
                Scan your own site free, then unlock the full report with {issuesCount}+ actionable insights
              </p>
            </div>

            {/* Right side - Price and CTA */}
            <div className={styles.ctaContent}>
              <div className={styles.priceBlock}>
                <span className={styles.priceLabel}>One-time</span>
                <div className={styles.price}>
                  <span className={styles.currency}>$</span>
                  <span className={styles.amount}>99</span>
                </div>
                <span className={styles.priceNote}>Scan is free</span>
              </div>

              <Link href="/audit" className={styles.ctaButton}>
                Analyze Your Site
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>

          {/* Trust indicators */}
          <div className={styles.trustBar}>
            <span className={styles.trustItem}>167 Audit Criteria</span>
            <span className={styles.trustDivider}>•</span>
            <span className={styles.trustItem}>PDF Report Included</span>
            <span className={styles.trustDivider}>•</span>
            <span className={styles.trustItem}>{GUARANTEE.en.badge}</span>
          </div>
        </div>
      </div>

    </>
  );
}
